// @flow

const lightShadow = "0 0 4px 0 rgba(0, 0, 0, 0.16)";
const defaultShadow = "0 2px 4px 0 rgba(0, 0, 0, 0.08);";
const bottomShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.08)";
const leftShadow = "-1px 0 2px 0 rgba(0, 0, 0, 0.12)";

export { lightShadow, defaultShadow, bottomShadow, leftShadow };
